import { cn } from '@/utils/cn';

interface CollapsibleProps {
  visible: boolean;
  children: React.ReactNode;
  className?: string;
}

export const Collapsible = ({ visible, children, className }: CollapsibleProps) => {
  return (
    <div
      aria-hidden={!visible}
      className={cn(
        'grid transition-all duration-300 ease-in-out',
        visible ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0 -mb-[18px] pointer-events-none',
        className
      )}
    >
      <div className="overflow-hidden min-h-0">{children}</div>
    </div>
  );
};
